/// <reference path="../vendor.d.ts"/>

namespace Ahb {
    namespace Types {
        export class ValidationFunctionList {
            private validationFunctions;

            constructor() {
                this.validationFunctions = {};
            }

            updateValidationConfiguration() {
                for (let formSelector in this.validationFunctions) {
                    if (this.validationFunctions.hasOwnProperty(formSelector)) {
                        // http://stackoverflow.com/questions/10304485/execute-html5-data-string-as-javascript-without-eval
                        const configFunction: any = window[this.validationFunctions[formSelector]];

                        if (!configFunction) {
                            return;
                        }

                        // Check whether we need to force a refresh
                        // Do this by storing a flag on the Function object itself to monitor whether it's already been run.
                        // If it has been run already, don't force it (but still run it anyway in case the validator object
                        // is not there, e.g. if the form is new, or the validator has been removed).
                        const forceRefresh = !configFunction.isAlreadyRun;
                        configFunction(forceRefresh);

                        // Refreshed, don't need to do it again
                        configFunction.isAlreadyRun = true;
                    }
                }
            }

            storeValidationFunction(formSelector, functionName) {
                this.validationFunctions[formSelector] = functionName;
            }

            listValidationFunctions() {
                let str = "";
                for (let formSelector in this.validationFunctions) {
                    if (this.validationFunctions.hasOwnProperty(formSelector)) {
                        str += `${this.validationFunctions[formSelector]} validates ${formSelector}\r\n`;
                    }
                }
                return str;
            }
        }
    }

// Different libraries use different format strings
// Datejs: https://code.google.com/p/datejs/wiki/FormatSpecifiers
    export const NZ_DATE_FORMAT_DISPLAY_DATE_JS = "dd/MM/yyyy"; // Display NZ dates
    export const NZ_DATE_FORMAT_PARSE_DATE_JS = "d/M/yyyy"; // Parse NZ dates (allow day/month with or without padding zero)
    export const INVARIANT_DATE_FORMAT_DATE_JS = "yyyy-MM-dd";
    export const NZ_DATE_FORMAT_DATETIME_JS = "dd/MM/yyyy HH:mm:ss tt";
    export const TIME_FORMAT_DATE_JS = "HH:mm"; // 24-hour

// jQuery UI: http://api.jqueryui.com/1.8/datepicker/
    export const NZ_DATE_FORMAT_JQUERY_UI = "dd/mm/yy";

    export module Utilities {
        var validationFunctionList = new Types.ValidationFunctionList();
        var $ = jQuery;

        export function scanValidationScripts(html?) {
            // If an element is not specified, scan the entire document
            html = html || $(document);
            const selector = "script[data-scripttype='validation']";

            $(html)
                .filter(selector)
                .add($(html).find(selector))
                .each(function () {
                    const formSelector = $(this).data("formselector");
                    const functionName = $(this).data("configfunction");

                    validationFunctionList.storeValidationFunction(formSelector, functionName);
                });
        }

        export function listValidationFunctions() {
            return validationFunctionList.listValidationFunctions();
        }

        export function updateValidationConfiguration(rescan?) {
            if (rescan) {
                scanValidationScripts();
            }

            validationFunctionList.updateValidationConfiguration();
        }

        export function extendWithTokenValue(obj, tokenName, tokenContainerElem) {
            const selector = `input[name='${tokenName}']`;
            let token;
            if (tokenContainerElem) {
                token = $(tokenContainerElem).find(selector).val();
            } else {
                token = $(selector).val();
            }

            obj[tokenName] = token;
        }

        export function addPostTokens(obj, tokenContainerElem?) {
            extendWithTokenValue(obj, "__RequestVerificationToken", tokenContainerElem);
            extendWithTokenValue(obj, "__ConcurrencyValuesToken", tokenContainerElem);
            return obj;
        }

        export function getConcurrencyValues(tokenContainerElem) {
            const tokenElem = tokenContainerElem.find("input[name='__ConcurrencyValuesToken']");
            const tokenVal = tokenElem.val();
            return JSON.parse(tokenVal);
        }

        export function setConcurrencyValues(tokenContainerElem, concurrencyValues) {
            const tokenElem = tokenContainerElem.find("input[name='__ConcurrencyValuesToken']");
            const tokenVal = JSON.stringify(concurrencyValues);
            tokenElem.val(tokenVal);
        }

        export function addOrUpdateConcurrencyValues(tokenContainerElem, newConcurrencyValues) {
            var existingConcurrencyValues = getConcurrencyValues(tokenContainerElem);
            $.each(newConcurrencyValues,
                (groupIndex, newGroup: any) => {
                    var existingGroup = existingConcurrencyValues.find(group => (group.FullTypeName === newGroup.FullTypeName));

                    if (existingGroup) {
                        $.each(newGroup.Ids,
                            (idIndex, id) => {
                                var lockVersion = newGroup.LockVersions[idIndex];
                                var existingIdIndex = existingGroup.Ids.indexOf(id);
                                if (existingIdIndex !== -1) {
                                    // Entity exists - update the LockVersion value
                                    existingGroup.LockVersions[existingIdIndex] = lockVersion;
                                } else {
                                    // Entity doesn't exist - add the ID and the LockVersion
                                    existingGroup.Ids.push(id);
                                    existingGroup.LockVersions.push(lockVersion);
                                }
                            });
                    } else {
                        // New group doesn't exist yet - add it.
                        existingConcurrencyValues.push(newGroup);
                    }
                });

            setConcurrencyValues(tokenContainerElem, existingConcurrencyValues);
        }

        export function stringToInt(stringValue): number {
            if (!stringValue) {
                return 0;
            }

            if (typeof stringValue === "number") {
                return Math.round(stringValue);
            }

            return parseInt(stringValue.match(/^\d+$/)) || 0;
        }

        export function elemToInt(jqueryInputElem): number {
            return stringToInt(jqueryInputElem.val());
        }

        export function padWithZeros(number, minDigits: number): string {
            let paddedNumber = number.toString();
            minDigits -= paddedNumber.length;
            if (minDigits > 0) {
                paddedNumber = Array(minDigits + (/\./.test(number) ? 2 : 1)).join('0') + number;
            }

            return paddedNumber;
        }

        export function padElemWithZeros(jqueryInputElem, minDigits) {
            const stringValue = jqueryInputElem.val();
            const intValue = stringToInt(stringValue);

            if (intValue) {
                jqueryInputElem.val(padWithZeros(intValue, minDigits));
            }
        }

        export function getSumOfFieldValues(fields) {
            var total = 0;
            fields.each(function () {
                total += elemToInt($(this));
            });

            return total;
        }

        export function getDifferenceInHours(date1InputElem, time1InputElem, date2InputElem, time2InputElem) {

            // Combine the date and time fields into a string of known format, which we
            // can then parse as a date/time.
            // The time elements are already assumed to contain values in HH:mm format
            const date1String = elemToDate($(date1InputElem)).toString(INVARIANT_DATE_FORMAT_DATE_JS) +
                $(time1InputElem).val();
            const date2String = elemToDate($(date2InputElem)).toString(INVARIANT_DATE_FORMAT_DATE_JS) +
                $(time2InputElem).val();

            const diff = Date.parseExact(date2String, INVARIANT_DATE_FORMAT_DATE_JS + TIME_FORMAT_DATE_JS).getTime() -
                Date.parseExact(date1String, INVARIANT_DATE_FORMAT_DATE_JS + TIME_FORMAT_DATE_JS).getTime();

            const hours = diff / 1000 / 60 / 60;

            return hours;
        }

        export function getQuerystring(key, defaultValue) {
            if (defaultValue == null) defaultValue = "";
            key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            const regex = new RegExp(`[\\?&]${key}=([^&#]*)`);
            const qs = regex.exec(window.location.href);
            if (qs == null)
                return defaultValue;
            else
                return qs[1];
        }

        export function stringToBool(stringValue: string) {
            if (stringValue.toLowerCase() === "true") {
                return true;
            }

            return false;
        }

        export function stringToDate(stringValue) {
            // If stringValue is 8 digits long, parse it as ddMMyyyy and return "dd/MM/yyyy"
            // If stringValue is 4 digits long, parse it as ddMM and return "dd/MM/yyyy" (with the current year)
            // Otherwise, return it unmolested (including if it's an invalid date e.g. 3104)

            const originalStringValue = stringValue;

            if (stringValue.match(/^\d{4}$/)) {
                // 4 digits long: tack on the year
                stringValue = stringValue + Date.today().toString("yyyy");
            }

            if (stringValue.match(/^\d{8}$/)) {
                // 8 digits long: parse as a date
                const stringParsedAsDate = Date.parseExact(stringValue, "ddMMyyyy");

                // If parsed successfully, insert the slashes and return
                if (stringParsedAsDate != null) {
                    // Format using the datejs library
                    return stringParsedAsDate.toString(NZ_DATE_FORMAT_DISPLAY_DATE_JS);
                }
            }

            // If we're down here, we couldn't parse as a date so return the original string value
            return originalStringValue;
        }


        // This function formats a date string as returned from a JSON call (e.g. "/Date(1224043200000)/") into a human-readable
        // date string of the form dd/mm/yyyy.
        // See http://stackoverflow.com/questions/206384/how-to-format-a-json-date
        export function jsonDateStringToDate(jsonDateString) {
            if (jsonDateString == null || !jsonDateString.match(/.{6}\d\d.*/)) {
                return null;
            }
            const parsedDate: any = new Date(parseInt(jsonDateString.substr(6)));
            return parsedDate.toString(NZ_DATE_FORMAT_DISPLAY_DATE_JS);
        }


        export function parseNzDateString(value) {
            return Date.parseExact($.trim(value), NZ_DATE_FORMAT_PARSE_DATE_JS);
        }


        export function toNzDateString(dateValue) {
            return dateValue.toString(NZ_DATE_FORMAT_DISPLAY_DATE_JS);
        }


        export function elemToDate(field) {
            const value = $.trim($(field).val());

            //if date is in ddMMyyyy format, format it to dd/mm/yyyy
            const match = value.match(/^\d{8}$/);

            let currentDate;

            if (match) {
                currentDate = Date.parseExact(value, "ddMMyyyy");
            } else {
                currentDate = Date.parseExact(value, NZ_DATE_FORMAT_PARSE_DATE_JS);

                if (currentDate == null)
                    currentDate = Date.parseExact(value, NZ_DATE_FORMAT_DATETIME_JS);
            }

            return currentDate;

        }

        // If a date is to be passed to the server using an HTTP GET request, it will be parsed by the
        // default model binder using the invariant culture.
        // http://weblogs.asp.net/melvynharbour/archive/2008/11/21/mvc-modelbinder-and-localization.aspx
        // This can be used to convert an NZ-formatted date string to the invariant culture
        export function nzDateStringToInvariant(nzDateString) {
            // Use the datejs library to parse and then reformat the date
            const date = parseNzDateString(nzDateString);
            if (date) {
                return date.toString(INVARIANT_DATE_FORMAT_DATE_JS);
            }

            return null;
        }

        export function getDateDifferenceInHours(field1, field2) {

            const date1 = elemToDate(field1);
            const date2 = elemToDate(field2);
            const diff: any = new Date(date2 - date1);
            const hours = diff / 1000 / 60 / 60;

            return hours;

        }

        export function convertTo24Time(control) {

            let fieldValue = control.val().replace(":", "");

            //left pad with 0
            while (fieldValue.length < 4) {
                fieldValue = `0${fieldValue}`;
            }

            const match = fieldValue.match(/^((0[0-9])|(1[0-9])|(2[0-3]))([0-5][0-9])$/);
            if (match) {

                control.val(fieldValue.substring(0, 2) + ":" + fieldValue.substring(2, 4));
            } else
                control.val("");
        }

        export function showLoader(show, loader) {
            if (loader) {
                if (show) {
                    loader.show();
                } else {
                    loader.hide();
                }
            }
        };

        export function enableElement(enable, element) {
            if (element) {
                // Allow for multiple callers to enable/disable the same element,
                // and only re-enable when they've all enabled it.
                let disabledCount = element.data("disabled-count") || 0;
                if (enable) {
                    disabledCount--;
                } else {
                    disabledCount++;
                }

                element.data("disabled-count", disabledCount);
                if (disabledCount <= 0) {
                    element.removeAttr("disabled");
                } else {
                    element.attr("disabled", "disabled");
                }
            }
        };

        export function ajaxGetJson(options) {

            var settings = $.extend({
                url: null,
                data: null,
                loaderSelector: null,
                triggerElement: null,
                callback: null,
                async: true
            },
                options);

            enableElement(false, settings.triggerElement);

            var loader = null;
            if (settings.loaderSelector) {
                loader = $(settings.loaderSelector);
            } else if (settings.triggerElement) {
                loader = settings.triggerElement.find("[data-usage='loader']");
            }

            showLoader(true, loader);

            $.ajax({
                url: settings.url,
                data: settings.data,
                type: "GET",
                async: settings.async,
                dataType: "json",
                global: true, // Propagage failure to global handler
                success: data => {
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);
                    settings.callback(data);
                },
                error: () => {
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);
                }
            });
        }

        export function ajaxGetData(options) {

            var settings = $.extend({
                url: null,
                id: null,
                requestData: null,
                dataType: null,
                async: true,
                loaderSelector: null,
                triggerElement: null,
                containerSelector: null,
                callback: null,
                appendToContainer: false,
                dataProcessor: data => data
            },
                options);

            enableElement(false, settings.triggerElement);

            var loader = null;
            if (settings.loaderSelector) {
                loader = $(settings.loaderSelector);
            } else if (settings.triggerElement) {
                loader = settings.triggerElement.find("[data-usage='loader']");
            }

            showLoader(true, loader);

            let requestData = settings.requestData;
            if (settings.id) {
                requestData = $.extend(requestData, { 'id': settings.id });
            }

            $.ajax({
                url: settings.url,
                data: requestData,
                dataType: settings.dataType,
                async: settings.async,
                type: "GET",
                global: true, // Propagage failure to global handler
                success: data => {
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);

                    if (settings.dataProcessor) {
                        data = settings.dataProcessor.call(null, data);
                    }

                    if (settings.containerSelector) {
                        if (settings.appendToContainer) {
                            $(settings.containerSelector).after(data);
                        } else {
                            $(settings.containerSelector).htmlWithValidation(data);
                        }

                        $(settings.containerSelector).find("input[type=text]").first().select();
                    }

                    if (settings.callback) {
                        settings.callback(data);
                    }
                },
                error: () => {
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);
                }
            });
        }

        export function ajaxPostData(options) {

            var settings = $.extend({
                url: null,
                data: null,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                dataType: null,
                traditional: false,
                triggerElement: null,
                containerSelector: null,
                callback: null,
                cleanupOnReplace: true,
                loaderSelector: null,
                prePopulateCallback: null,
                dataProcessor: data => data
            },
                options);

            enableElement(false, settings.triggerElement);

            var loader = null;
            if (settings.loaderSelector) {
                loader = $(settings.loaderSelector);
            } else if (settings.triggerElement) {
                loader = settings.triggerElement.find("[data-usage='loader']");
            }

            showLoader(true, loader);

            $.ajax({
                url: settings.url,
                data: settings.data,
                traditional: settings.traditional,
                global: true, // Propagage failure to global handler
                type: "POST",
                contentType: settings.contentType,
                dataType: settings.dataType,
                success: data => {

                    if (settings.dataProcessor) {
                        data = settings.dataProcessor.call(null, data);
                    }

                    if (settings.prePopulateCallback) {
                        settings.prePopulateCallback();
                    }

                    if (settings.containerSelector) {
                        if (settings.cleanupOnReplace) {
                            $(settings.containerSelector).htmlWithValidation(data);
                        } else {
                            // http://www.novogeek.com/post/The-curious-case-of-Stop-running-script-error-jQuery.aspx
                            $(settings.containerSelector)[0].innerHTML = data;
                        }
                    }

                    // Update elements state before calling the callback, in case the callback does something
                    // with element state.
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);

                    if (settings.callback) {
                        settings.callback(data);
                    }
                },
                error: () => {
                    showLoader(false, loader);
                    enableElement(true, settings.triggerElement);
                }
                });
            }

            export function ajaxPostForm(options) {

                const settings = $.extend({
                        url: null,
                        formSelector: null,
                        suppressValidation: false,
                        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                        dataType: null,
                        traditional: false,
                        triggerElement: null,
                        containerSelector: null,
                        callback: null,
                        cleanupOnReplace: true,
                        loaderSelector: null,
                        prePopulateCallback: null,
                        dataProcessor: data => data
                    },
                    options);

                let form;
                if (settings.formSelector) {
                    form = $(settings.formSelector);
                } else {
                    form = settings.triggerElement.closest("form");
                }

                settings.url = settings.url || form.attr("action");

                const result = settings.suppressValidation || form.validate().form();

                if (result) {
                    settings.data = form.serialize();
                    ajaxPostData(settings);
                }
            }

            // Create an error string representing a jQuery XmlHttpRequest that's failed
            export function formatJqXhrFailure(jqXhr) {
                return `Ajax request error: ${jqXhr.statusText} (${jqXhr.status})\r\n${jqXhr.responseText}`;
            }

            // Workaround to remove spaces between </td> and next <td>. Having spaces causes a bug to surface in IE
            // whereby occasional table cells are offset. See:
            // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/e6f49d52-ec3f-47c5-802e-b80d1a58ed39/
            // http://stackoverflow.com/questions/7267014/ie9-table-has-random-rows-which-are-offset-at-random-columns
            export function stripInterElementWhitespace(data) {
                const expr = new RegExp(">[ \t\r\n\v\f]*<", "g");
                return data.replace(expr, "><");
        }

        export function ensureDivExists(divId) {
                // Create the div outside the form, if it doesn't exist
                const divSelector = `#${divId}`;
                const div = $(divSelector);
                if (!div.length) {
                    $("<div>").attr("id", divId).appendTo($("body"));
                }
            }

            export function clearDropDown(dropDown) {
                dropDown.attr("disabled", "disabled");

                /* Reset to default value */
                dropDown.val("");
            }

            export function filterDropDown(options) {

                var settings = $.extend({
                    dropDown: null,
                    url: null,
                    params: {},
                    blankSelectionText: "--- Select a value ---",
                    withGrouping: false
                },
                    options);

                /* Get the current value before clearing the drop-down */
                var currentValue = settings.dropDown.val();

                var clearList = () => {
                    /* Clear the drop-down and add a default ('select a value') option */
                    settings.dropDown.find("option").remove();
                    settings.dropDown.find("optgroup").remove();
                    $(`<option value=''''>${settings.blankSelectionText}</option>`).appendTo(settings.dropDown);
                };

                clearList();

                /* Repopulate child with options from call to server */
                $.post(settings.url,
                    addPostTokens(settings.params),
                    data => {

                        // Clear the list a second time when the response comes back, in case it has been populated
                        // in the meantime by another response.
                        clearList();

                        if (!settings.withGrouping) {
                            $(data)
                                .each(function () {
                                    $(`<option value=${this.Value}>${this.Text}</option>`)
                                        .appendTo(settings
                                            .dropDown);
                                });
                        } else {
                            $.each(data,
                                (key, cat) => {
                                    var group = $("<optgroup>", { label: cat.Name });

                                    $.each(cat.Items,
                                        (i, item) => {
                                            $("<option/>", { value: item.Value, text: item.Text })
                                                .appendTo(group);
                                        });

                                    group.appendTo(settings.dropDown);
                                });
                        }

                        /* Re-select the current value if it's still there */
                        if (currentValue !== "" &&
                            settings.dropDown.find(`option[value=${currentValue}]`).length > 0
                        ) {
                            settings.dropDown.val(currentValue);
                        }

                        settings.dropDown.removeAttr("disabled");

                        settings.dropDown.trigger("chosen:updated");

                    })
                    .fail(jqXhr => {
                        // http://stackoverflow.com/questions/9229005/how-to-handle-jquery-ajax-post-error-when-navigating-away-from-a-page
                        if (jqXhr.status !== 0) {
                            const msg = `Error filtering drop-down '${settings.dropDown.attr("id")}'\r\n${formatJqXhrFailure(jqXhr)}`;

                            throw new Error(msg);
                        }
                    });
            }

            export function rechosen(dropDown, options) {
                //use the purpose-built cleanup added in chosen 0.14
                dropDown.chosen("destroy");
                dropDown.chosen(options);
            }

            export function showAddContactDialog(button, saveCallback) {
                const url = button.data("url");

                ensureDivExists("addContactDialogContainer");

                ajaxGetData({
                    url: url,
                    triggerElement: button,
                    containerSelector: "#addContactDialogContainer",
                    callback: () => {
                        $("#addContactDialogContainer")
                            .children()
                            .first()
                            .insiteDialog({
                                preSaveCallback: () => {
                                    // Used by the validation code in the dialog
                                    window.isSavedClicked = true;
                                },
                                saveCallback: saveCallback
                            });
                    }
                });
            }

            export function refreshCtaNotifications() {
                // Remove any existing notification
                $(".cta-notification").remove();

                // Find all the CTAs for the current user on the page and return if there are none
                const currentUserCtas = $("body").find("[data-usage='cta_result'][data-show_notification='true']");
                if (currentUserCtas.length === 0) {
                    return;
                }

                if ($("body").data("hide_cta_notifications")) {
                    return;
                }

                // Create a notification to display the CTAs
                const notification = $("<div>").addClass("cta-notification").appendTo($("body"));
                const closeButton = $("<button>").addClass("cta-close").text("Close").appendTo(notification);
                closeButton.click(() => {
                    $("body").data("hide_cta_notifications", true);
                    refreshCtaNotifications();
                });

                $("<h4>").text("My open CTAs").appendTo(notification);

                var ctaIds = [];

                var ctaTable = $("<table>").appendTo(notification);
                currentUserCtas.each(function () {
                    var ctaContainer = $(this);

                    // Don't add more than one notification for a given CTA.
                    var ctaId = ctaContainer.data("cta_id");
                    if ($.inArray(ctaId, ctaIds) >= 0) {
                        return;
                    } else {
                        ctaIds.push(ctaId);
                    }

                    const tr = $("<tr>").appendTo(ctaTable);
                    const actionCell = $("<td>")
                        .text(ctaContainer
                            .data("action_type"))
                        .addClass("clickable")
                        .appendTo(tr);
                    actionCell.click(() => {
                        if (!ctaContainer.is(":visible")) {
                            const ctaSearchResultsContainer = ctaContainer
                                .closest("[data-usage='cta_search_results_container']");
                            const expando = ctaSearchResultsContainer.find("[data-usage='cta_expando_handle']");
                            const expandoData = expando.data("expando_data");
                            expandoData.setExpanded(true);
                        }
                        // http://stackoverflow.com/questions/6677035/jquery-scroll-to-element
                        $("html, body")
                            .animate({
                                scrollTop: ctaContainer.offset().top
                            },
                            400);
                    });

                    var resultsContainer = ctaContainer.closest("[data-usage='cta_search_results_container']");
                    const markCompleteCell = $("<td>").appendTo(tr);
                    var markCompleteButton = $("<button>").addClass("btn").text("Done").appendTo(markCompleteCell);
                    markCompleteButton.click(() => {
                        ensureDivExists("ctaDialogContainer");
                        ajaxPostData({
                            triggerElement: markCompleteButton,
                            data: addPostTokens({ callToActionIds: [ctaId] }),
                            traditional: true,
                            url: resultsContainer.data("mark_as_complete_url"),
                            containerSelector: "#ctaDialogContainer",
                            suppressValidation: true,
                            callback: () => {
                                $("#ctaDialogContainer")
                                    .children()
                                    .first()
                                    .insiteDialog({
                                        saveCallback: () => {
                                            resultsContainer.trigger("ctasupdated");
                                        }
                                    });
                            }
                        });
                    });
                });
            }
    }
}

window.Ahb = Ahb;


// WEBPACK FOOTER //
// ./ScriptsTS/Utilities.ts